<div [innerHTML]="html" [ngClass]="getSpacingStyle()" #myDiv></div>